(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luv-email-signup"] && !Shopify.designMode) return;
  try {
    
  const luvEmailFrameStyleText = [
    'html,body,#conversions_layers_root{min-height:0!important;height:auto!important;}',
    'body{margin:0!important;overflow:hidden!important;}',
    '.luv-frame-hidden{display:none!important;}',
    '.luv-frame-shell{padding:0!important;}',
    '.luv-frame-box{padding:0!important;}',
    '.luv-frame-stack{width:100%!important;margin:0!important;}',
    '.luv-frame-stack>.mars-stack-item:not(.luv-frame-form-wrapper){display:none!important;}',
    '.luv-frame-form-wrapper{width:100%!important;margin:0!important;}',
    '.luv-frame-form-item{width:100%!important;margin:0!important;}',
    '.luv-frame-content-row{width:100%!important;margin:0!important;}',
    '.luv-frame-shell>div{max-width:100%!important;}',
    'form{width:100%!important;max-width:520px!important;margin:0 auto!important;}',
    '.luv-frame-row{display:grid!important;grid-template-columns:minmax(0,1fr) 140px!important;align-items:stretch!important;gap:12px!important;width:100%!important;height:auto!important;margin:0!important;}',
    '.luv-frame-row>*{width:auto!important;margin:0!important;}',
    '.luv-frame-input{height:56px!important;border-radius:0!important;}',
    '.luv-frame-input input{font-family:Arial,Helvetica,sans-serif!important;}',
    '.luv-frame-row button{height:56px!important;min-height:56px!important;border-radius:0!important;box-shadow:none!important;padding:0 20px!important;}',
    '.luv-frame-row button span{font-family:Arial,Helvetica,sans-serif!important;}',
    '.luv-frame-row button span span{font-size:14px!important;font-weight:600!important;letter-spacing:.08em!important;}',
    '@media(max-width:420px){.luv-frame-row{grid-template-columns:1fr!important;gap:10px!important;}}'
  ].join('');

  const resizeLuvEmailFrame = (frame, doc) => {
    const height = Math.ceil(Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight));
    if (Math.abs(frame.getBoundingClientRect().height - height) > 1) {
      frame.style.setProperty('height', height + 'px', 'important');
    }

    if (frame.parentElement && Math.abs(frame.parentElement.getBoundingClientRect().height - height) > 1) {
      frame.parentElement.style.setProperty('height', height + 'px', 'important');
    }
  };

  const refineLuvEmailFrame = (section, frame) => {
    try {
      const doc = frame.contentDocument;
      const form = doc && doc.querySelector('form');

      if (!form || !form.firstElementChild) {
        return false;
      }

      if (!doc.getElementById('luv-email-frame-styles')) {
        const style = doc.createElement('style');
        style.id = 'luv-email-frame-styles';
        style.textContent = luvEmailFrameStyleText;
        doc.head.appendChild(style);
      }

      const originalCopy = Array.from(doc.querySelectorAll('p')).find((element) => {
        return !form.contains(element) && element.textContent.trim();
      });

      if (originalCopy) {
        const originalCopyContainer = originalCopy.closest('.mars-stack-item') || originalCopy;
        originalCopyContainer.remove();
      }

      const originalTitle = Array.from(doc.querySelectorAll('span')).find((element) => {
        return !form.contains(element) && element.style.fontSize === '2.25rem';
      });

      if (originalTitle) {
        const originalTitleContainer =
          originalTitle.closest('.mars-stack-item') || originalTitle.parentElement || originalTitle;
        originalTitleContainer.remove();
      }

      const shell = form.closest('div[style*="padding-bottom"]');

      if (shell) {
        shell.classList.add('luv-frame-shell');
      }

      const box = form.closest('.MuiBox-root');
      if (box) {
        box.classList.add('luv-frame-box');
      }

      const embeddedContent = form.closest('span');
      const embeddedItem = embeddedContent && embeddedContent.parentElement;
      if (embeddedItem) {
        embeddedItem.classList.add('luv-frame-form-wrapper');
        if (embeddedItem.parentElement) {
          embeddedItem.parentElement.classList.add('luv-frame-stack');
        }
      }

      const formItem = form.closest('.mars-stack-item');
      if (formItem) {
        formItem.classList.add('luv-frame-form-item');
        if (formItem.parentElement) {
          formItem.parentElement.classList.add('luv-frame-content-row');
        }
      }

      const row = form.firstElementChild;
      row.classList.add('luv-frame-row');

      const input = form.querySelector('input[type="email"]');

      if (input && input.parentElement) {
        input.parentElement.classList.add('luv-frame-input');
      }

      const button = form.querySelector('button');
      const buttonLabel = section.dataset.buttonLabel || 'JOIN';

      if (button) {
        const labels = Array.from(button.querySelectorAll('span')).filter((element) => {
          return element.children.length === 0 && element.textContent.trim();
        });
        const visibleLabel = labels[labels.length - 1];

        if (visibleLabel) {
          visibleLabel.textContent = buttonLabel;
        }

        button.setAttribute('aria-label', buttonLabel);
      }

      frame.setAttribute('title', section.dataset.frameTitle || 'Email sign up');
      section.classList.add('is-refined');
      resizeLuvEmailFrame(frame, doc);

      if (!frame.dataset.luvResizeObserved && frame.contentWindow.ResizeObserver) {
        const observer = new frame.contentWindow.ResizeObserver(() => {
          resizeLuvEmailFrame(frame, doc);
        });
        observer.observe(doc.body);
        frame.dataset.luvResizeObserved = 'true';
      }

      if (!frame.dataset.luvStyleObserved) {
        const styleObserver = new MutationObserver(() => {
          resizeLuvEmailFrame(frame, doc);
        });
        styleObserver.observe(frame, {
          attributes: true,
          attributeFilter: ['style', 'height'],
        });
        frame.dataset.luvStyleObserved = 'true';
      }

      return true;
    } catch (error) {
      return false;
    }
  };

  const setupLuvEmailSignup = (section) => {
    if (section.dataset.luvEmailSetup === 'true') {
      return;
    }

    section.dataset.luvEmailSetup = 'true';
    let activeFrame;

    const attempt = () => {
      const frame = section.querySelector('iframe[src*="/apps/automizely-messages/layers/embedded/"]');

      if (!frame) {
        return false;
      }

      if (frame !== activeFrame) {
        activeFrame = frame;
        frame.addEventListener('load', () => {
          refineLuvEmailFrame(section, frame);
        });
      }

      return refineLuvEmailFrame(section, frame);
    };

    const mutationObserver = new MutationObserver(attempt);
    mutationObserver.observe(section, { childList: true, subtree: true });

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;

      if (attempt() || attempts >= 20) {
        window.clearInterval(timer);
      }
    }, 300);
  };

  const initialiseLuvEmailSignups = (root) => {
    root.querySelectorAll('[data-luv-email-signup]').forEach(setupLuvEmailSignup);
  };

  const startLuvEmailSignups = () => {
    initialiseLuvEmailSignups(document);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startLuvEmailSignups, { once: true });
  } else {
    startLuvEmailSignups();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.matches('[data-luv-email-signup]')) {
      setupLuvEmailSignup(event.target);
    } else {
      initialiseLuvEmailSignups(event.target);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
